/*
 * ProduktPilot24: Partner-Tag je Kanal (Amazon-PartnerNet Tracking-IDs).
 * Kommt der Besuch ueber einen bekannten Kanal (utm_source / utm_medium=bio / Google-Referrer),
 * bekommt jeder Amazon-Link auf der Seite das passende tag=. Die Metafelder der Produkte bleiben unveraendert
 * (Standard produktpilo02-21), umgeschrieben wird nur im Browser beim Rendern und beim Klick.
 * Datenschutz: Es wird NICHTS im Browser gespeichert (kein Cookie, kein localStorage, kein sessionStorage).
 * Der Kanal steckt nur in der URL und wird auf interne Links weitergereicht. Keine Pixel, keine Daten an Dritte.
 */
(function () {
  'use strict';

  var DEFAULT_TAG = 'produktpilo02-21';
  var TAGS = {
    bio: 'pp24bio-21',
    instagram: 'pp24insta-21',
    tiktok: 'pp24tiktok-21',
    pinterest: 'pp24pin-21',
    youtube: 'pp24yt-21',
    google: 'pp24google-21'
  };
  var ALIAS = {
    instagram: 'instagram', ig: 'instagram', insta: 'instagram',
    tiktok: 'tiktok', tt: 'tiktok',
    pinterest: 'pinterest', pin: 'pinterest',
    youtube: 'youtube', yt: 'youtube',
    google: 'google'
  };
  var KEEP = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var SKIP_PATHS = /^\/(cart|checkout|checkouts|account|admin|apps|services|wpm|cdn|\.well-known)(\/|$)/;
  var AMAZON_HOST = /(^|\.)amazon\.(de|com|co\.uk|fr|it|es|nl|pl|se|com\.be|ie)$/i;

  function detect() {
    var q;
    try { q = new URLSearchParams(window.location.search); } catch (e) { return null; }
    var source = (q.get('utm_source') || '').toLowerCase();
    var medium = (q.get('utm_medium') || '').toLowerCase();
    var channel = null;
    var carry = {};
    var i;

    for (i = 0; i < KEEP.length; i++) {
      var v = q.get(KEEP[i]);
      if (v) carry[KEEP[i]] = v;
    }

    if (medium === 'bio') {
      channel = 'bio';
    } else if (source) {
      channel = ALIAS[source] || null;
    } else {
      try {
        if (document.referrer) {
          var rh = new URL(document.referrer).hostname;
          if (/(^|\.)google\.[a-z.]+$/i.test(rh) && rh !== window.location.hostname) {
            channel = 'google';
            carry = { utm_source: 'google' };
          }
        }
      } catch (e) { /* kein Referrer */ }
    }

    if (!channel) return null;
    return { channel: channel, tag: TAGS[channel], carry: carry };
  }

  var info = detect();
  if (!info) return;
  document.documentElement.setAttribute('data-pp-channel', info.channel);

  function processLink(a) {
    if (!a || !a.getAttribute) return;
    var href = a.getAttribute('href');
    if (!href || href.charAt(0) === '#' || /^(mailto|tel|javascript):/i.test(href)) return;
    var u;
    try { u = new URL(href, window.location.href); } catch (e) { return; }
    if (u.protocol !== 'http:' && u.protocol !== 'https:') return;

    if (AMAZON_HOST.test(u.hostname)) {
      var cur = u.searchParams.get('tag');
      if (cur && (cur === DEFAULT_TAG || /^pp24[a-z]+-21$/.test(cur)) && cur !== info.tag) {
        u.searchParams.set('tag', info.tag);
        a.setAttribute('href', u.toString());
      }
      return;
    }

    if (u.host !== window.location.host) return;
    if (SKIP_PATHS.test(u.pathname)) return;
    if (u.pathname === window.location.pathname && u.search === window.location.search && u.hash) return;
    if (u.searchParams.get('utm_source')) return;

    var changed = false;
    for (var k in info.carry) {
      if (Object.prototype.hasOwnProperty.call(info.carry, k) && !u.searchParams.has(k)) {
        u.searchParams.set(k, info.carry[k]);
        changed = true;
      }
    }
    if (changed) a.setAttribute('href', u.pathname + u.search + u.hash);
  }

  function processAll(root) {
    var links = (root || document).querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) processLink(links[i]);
  }

  var timer = null;
  function schedule() {
    if (timer) return;
    timer = window.setTimeout(function () { timer = null; processAll(document); }, 150);
  }

  function onInteract(e) {
    var t = e.target;
    if (t && t.closest) processLink(t.closest('a[href]'));
  }

  processAll(document);
  document.addEventListener('DOMContentLoaded', function () { processAll(document); });
  window.addEventListener('load', function () { processAll(document); });
  ['mousedown', 'click', 'auxclick', 'touchstart', 'keydown'].forEach(function (ev) {
    document.addEventListener(ev, onInteract, true);
  });
  if ('MutationObserver' in window) {
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
